import { memo, useEffect } from "react";
import { useQuery } from "react-query";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import { mdlCountryListRequest } from "../../models/service-models/country/CountryListRequest";
import { CountryService } from "../../services/CountryService";

export type CountrySelectProps = {
    onChange?: Function;
    value?: any;
    mode?: "multiple" | "tags" | undefined;
}


export const CountrySelect = memo(function CountrySelect(props: CountrySelectProps) {
    const { t } = useTranslation();

    useEffect(() => {
        if (!data)
            refetch();
    }, []);

    const {
        data,
        isLoading,
        isError,
        refetch
    } = useQuery(
        ["getCountries"],
        () => {
            var request: mdlCountryListRequest = { pageSize: 0 };
            return CountryService.List(request);
        },
        {
            refetchOnWindowFocus: false,
            enabled: false
        }
    );

    const onFocus = () => {
        let i;
        const el = document.getElementsByClassName(
            "ant-select-selection-search-input"
        );
        for (i = 0; i < el.length; i++) {
            el[i].setAttribute(
                "autocomplete",
                "registration-select"
            );
        }
    }

    let countries = data?.body?.data;

    return (
        <>
            <Select
                mode={props.mode}
                loading={isLoading}
                onFocus={onFocus}
                size="middle"
                value={props.mode == "multiple" ? props.value as string[] : props.value as string}
                onChange={(value: string | string[]) => props.onChange ? props.onChange(value) : undefined}
                showSearch
                placeholder={t("common.chooseCountry")}
                filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                options={countries?.map(h => Object.assign(h, {
                    label: h.name,
                    value: h.id
                }))}
            />
        </>
    )
})